import api from '@/utils/api';

const { baseApi } = window.GlobalConfig;

export const queryDictAll = data => {
    return api.post(`${baseApi}/dictDictionary/getDictDictionaryList`, data);
};

export const queryDictList = data => {
    return api.post(`${baseApi}/component/getComponentDictDictionaryList`, data);
};

export const addDict = data => {
    return api.post(`${baseApi}/dictDictionary/addDictDictionary`, data);
};

export const updateDict = data => {
    return api.post(`${baseApi}/dictDictionary/updateDictDictionary`, data);
};

export const deleteDict = ({ dictId }) => {
    return api.get(`/dictDictionary/deleteDictDictionaryById/${dictId}`);
};

export const updateDictSort = data => {
    return api.post(`${baseApi}/dictDictionary/updateDictDictionaryBatch`, data);
};

export const QueryDictClassify = data => {
    return api.post(`${baseApi}/dictClassification/getDictClassificationList`, data);
};

export const SaveDictClassify = data => {
    return api.post(`${baseApi}/dictClassification/addDictClassification`, data);
};

export const UpdateDictClassify = data => {
    return api.post(`${baseApi}/dictClassification/updateDictClassification`, data);
};

export const SortDictClassify = data => {
    return api.post(`${baseApi}/dictClassification/updateDictClassificationBatch`, data);
};

export const QueryDictType = data => {
    return api.post(`${baseApi}/dictType/getDictTypeList`, data);
};

export const UpdateDictType = data => {
    return api.post(`${baseApi}/dictType/updateDictType`, data);
};

export const SaveDictType = data => {
    return api.post(`${baseApi}/dictType/addDictType`, data);
};

export const SortDictType = data => {
    return api.post(`${baseApi}/dictType/updateDictTypeBatch`, data);
};

export const QueryDictListByClassify = () => {
    return api.get(`${baseApi}`);
};

export const queryAreaTree = () => {
    return api.get(`${baseApi}/areaRegion/getAreaRegionTree`);
};

export const queryRegionList = data => {
    return api.post(`${baseApi}/areaRegion/getRegionList`, data);
};

export const addRegionArea = data => {
    return api.post(`${baseApi}/areaRegion/addRegion2Area`, data);
};

export const saveArea = data => {
    return api.post(`${baseApi}/areaRegion/saveArea`, data);
};

export const deleteArea = areaId => {
    return api.get(`${baseApi}/areaRegion/deleteArea/${areaId}`);
};

export const saveRegionControl = data => {
    return api.post(`${baseApi}/areaRegion/saveRegionControl`, data);
};

export const saveAreaControl = data => {
    return api.post(`${baseApi}/areaRegion/saveAreaControl`, data);
};

///  指标
export const queryQuotaList = data => {
    return api.post(`${baseApi}/expression/getExpressionFactorByGroupPage`, data);
};

export const addQuota = data => {
    return api.post(`${baseApi}/expression/updateExpressionFactor`, data);
};

export const queryQuotaByUserId = ({ userId }) => {
    return api.post(`${baseApi}/expression/getExpressionFactorByUserId/${userId}`);
};

/// 项目管理

export const queryClause = data => {
    return api.post(`${baseApi}/medicalItem/getMedicalItemPage`, data);
};

export const addClause = data => {
    return api.post(``, data);
};

export const submitClause = data => {
    return api.post(`${baseApi}/medicalItem/addMedicalItem`, data);
};

export const queryCustomerClause = data => {
    return api.post(`${baseApi}/customerMedicalItemRel/getCustomerMedicalItemRel4Customer`, data);
};

export const saveClauseCharge = data => {
    return api.post(`${baseApi}/customerMedicalItemRel/updateCustomerMedicalItemRel`, data);
};

export const relationClauseCustomer = data => {
    return api.post(`${baseApi}/customerMedicalItemRel/addCustomerMedicalItemRel`, data);
};

// 补充客户
export const querySupplyCustomer = data => {
    return api.post(`${baseApi}/customerOther/getCustomerOtherPage`, data);
};

export const addSupplyCustomer = data => {
    return api.post(`${baseApi}/customerOther/addCustomerOther`, data);
};

export const updateSupplyCustomer = data => {
    return api.post(`${baseApi}`, data);
};

export const deleteSupplyCustomer = ({ customerId }) => {
    return api.post(`${baseApi}/customerOther/removeCustomerOther/${customerId}`);
};

/// TEST

export const deleteWrong = data => {
    return api.post(`${baseApi}/backDoor/deleteWrongVisitPlanRelation`, data);
};

export const addCustomerDepartmentRelBack = () => {
    return api.post(`${baseApi}/backDoor/addCustomerDepartmentRel`);
};

// 科室

export const QueryRoomList = data => {
    return api.post(`${baseApi}/department/getDepartmentList`, data);
};

export const QueryRoomTree = () => {
    return api.get(`${baseApi}/departmentType/getDepartmentTypeTree`);
};

export const SaveRoom = data => {
    return api.post(`${baseApi}/departmentType/addDepartmentType`, data);
};

export const DeleteRoom = data => {
    return api.get(`${baseApi}/departmentType/deleteDepartmentType/${data.typeId}`);
};

export const UpdateRoom = data => {
    return api.post(`${baseApi}/departmentType/updateDepartmentType`, data);
};

export const UpdateSortRoom = data => {
    return api.post(`${baseApi}/departmentType/updateDepartmentTypeBatch`, data);
};

export const QueryConfigPage = data => {
    return api.post(`${baseApi}/config/getConfigListPage`, data);
};

export const UpdateConfig = data => {
    return api.post(`${baseApi}/config/updateConfig`, data);
};

// 项目关系

export const QueryBaseLeftCustomer = data => {
    return api.post(`${baseApi}/customer/getCustomerList4CustomerMedicalItemRelPage`, data);
};

export const UpdateMedicalItem = data => {
    return api.post(`${baseApi}/medicalItem/updateMedicalItem`, data);
};

// 联系人
export const QueryDoctorList = data => {
    return api.post(`${baseApi}`, data);
};

// 待办事项
export const QueryAgentList = data => {
    return api.get(`/home/getTodoList`, data);
};

// 模板

export const QueryKeypointTemplate = data => {
    return api.post(`/actionKeypointTemplate/getActionKeypointTemplateListPage`, data);
};

export const SaveKeypointTemplate = data => {
    return api.post(`/actionKeypointTemplate/addActionKeypointTemplate`, data);
};

export const UpdateKeypointTemplate = data => {
    return api.post(`/actionKeypointTemplate/updateActionKeypointTemplate`, data);
};

export const GetKeypointTemplateInfo = ({ templateId }) => {
    return api.get(`/actionKeypointTemplate/getActionKeypointTemplateById/${templateId}`);
};

export const DeleteKeypointTemplate = ({ templateId }) => {
    return api.get(`/actionKeypointTemplate/deleteActionKeypointTemplate/${templateId}`);
};

// 行动计划模板
export const QueryTemplateAction = ({ keypointTemplateId }) => {
    return api.post(`/actionPlanTemplate/getActionPlanTemplateListByKeypointTemplateId/${keypointTemplateId}`);
};

export const SaveTemplateAction = data => {
    return api.post(`/actionPlanTemplate/addActionPlanTemplate`, data);
};

export const UpdateTemplateAction = data => {
    return api.post(`/actionPlanTemplate/updateActionPlanTemplate`, data);
};

export const DeleteTemplateAction = ({ templateId }) => {
    return api.get(`/actionPlanTemplate/deleteActionPlanTemplate/${templateId}`);
};
